import React from "react";
import { useSelector } from "react-redux";
import { IntlProvider } from "react-intl";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import translations from "app/libs/i18n/translations.json";
/* Unified Signup component — defaultUserType="recruiter" */
import Signup from "bundles/Devise/Signup/components/Signup";

const SignupRecruiterContainer = () => {
  const i18nLocale = useSelector((state) => state.i18nLocale);
  const locale = i18nLocale;
  const messages =
    translations[locale] || (locale === "fr-fr" ? translations.fr : {});

  return (
    <IntlProvider locale={locale} key={locale} messages={messages}>
      <BrowserRouter>
        <Routes>
          <Route
            path={`/${i18nLocale}/recruiters/sign_up`}
            element={<Signup defaultUserType="recruiter" />}
          />
          <Route
            path={`/${i18nLocale}`}
            element={<Navigate to={`/${i18nLocale}/recruiters/sign_up`} />}
          />
        </Routes>
      </BrowserRouter>
    </IntlProvider>
  );
};

export default SignupRecruiterContainer;
